import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/app-component-base';

@Component({
  selector: 'app-custom-set-text-dialog',
  templateUrl: './custom-set-text-dialog.component.html',
})
export class CustomSetTextDialogComponent extends AppComponentBase {
  public nomeArquivo: string;
  @Output() onSave = new EventEmitter<string>();

  constructor(injector: Injector, public bsModalRef: BsModalRef) {super(injector)}

  protected save(): void{
    this.onSave.emit(this.nomeArquivo);
    this.bsModalRef.hide();
  }

}
